
<template>
<div>
    <div class="card shadow">
        <a id="button"></a>
        <div class="card-header bg-transparent">
            <div>
                <h3 class="mb-0">
                    {{ $t('message.add') }} {{ $tc('message.EtablissementPrix', 1) }}
                </h3>
            </div>
        </div>

        <b-container style="margin:10px" fluid="sm" class="card-body">
            <b-form @reset="onReset" v-if="show">
                <div>
                    <b-row>
                        <b-col sm="12">
                            <span class="obligatoire">*</span>
                            <b-form-group id="institution-group" :label="$t('message.nomEtablissement')" label-for="institution">
                                <select id="institution" v-model="$v.form.institution.$model" @change="clearErrorField('etablissement_id')" class="form-control is-invalid retirerBordure" required>
                                    <option data-placeholder="true"></option>
                                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                        {{ item.nom }}
                                    </option>
                                </select>
                                <b-form-invalid-feedback v-if="$v.form.institution.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                </span>
                            </b-form-group>
                        </b-col>

                    </b-row>
                    <b-row>
                        <div>
                            <b-table :items="complementaires" :fields="fields">
                                <!-- <div v-for="(c,key) in complementaires" :key="key">
                                    <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                        <div class="container">
                                            <div class="d-flex">
                                                <div class="overflow-auto p-2 mr-3" style=" max-height: 400px;">
                                                    <b-form-checkbox-group name="complementaires" v-model="complementaireChecked" @change="clearErrorField('examen_complementaire_id')" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked switch>
                                                        <b-form-checkbox v-for="(item, index) in c" :value="item" :key="index">
                                                            <span>{{item.fr_description}}</span> <b-form-input id="input-small" name="prix" size="sm" :value="item.prix"></b-form-input>
                                                        </b-form-checkbox>
                                                    </b-form-checkbox-group>
                                                </div>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </div> -->
                            </b-table>
                        </div>
                    </b-row>        
                    <b-row class="justify-content-sm-center">
                        <b-button @click="onSubmit" variant="primary" v-if="can">
                            {{ $t('message.save') }}
                        </b-button>
                    </b-row>
                </div>
            </b-form>

        </b-container>
    </div>
</div>
</template>


<script>
import {
    mapGetters
} from 'vuex';
import {
    required,
    minLength
} from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import moment from 'moment';
import $ from 'jquery';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../constants/AppConfig";
import {
    pagination,
    handlePaginationClick
} from "../../helpers/paginations";
import loading from 'vue-loading-overlay';
// import * as ECT from '@whoicd/icd11ect';
// import '@whoicd/icd11ect/style.css';
export default {
    name: "AddGeneralMedicine",

    components: {
        editor: Editor,
        loading
    },

    computed: {
        ...mapGetters([
            "practitioners",
            "controlDoctors",
            "reasons",
            "allergies",
            "institutions",
            "userInstitutions",
            "errors",
            'hasAdminRole',
            'hasMedecinControleRole',
            'hasPraticienRole',
            'Timelines'
        ]),

        mInstitutions: function () {
            let iArray = [];

            _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
                let i = {};

                i.nom = institution.name;
                i.description = (!_.isNull(institution.description) ? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                i.date = moment(institution.created_at).format('DD-MM-YYYY');
                i.id = institution.id;
                i.slug = institution.slug;

                iArray.push(i);
            });

            return iArray;
        },
        
        // tReasons: function () {
        //     let rArray = [];

        //     if (!_.isUndefined(this.Timelines)) {
        //         _.forEach(this.Timelines, function (timelines) {
        //             rArray.push({
        //                 name: reason.description,
        //                 value: reason.id
        //             })
        //         })
        //         return rArray;
        //     }
        //     return rArray;
        // },

        can: function () {
            if (this.hasAdminRole) {
                return true;
            } else {
                return this.hasMedecinControleRole || this.hasPraticienRole;
            }
        },

    },

    data() {
        return {
            complementaires: [],
            complementaireChecked: [],
            fields:[{key:'fr_description',label:'examen'},{key:'prix',label:'Prix'},{key:'slug',label:'code'},{key:'reference',label:'famille'}],
            form: {
                complementaire: [],
            },


            show: true,
        }
    },
    methods: {

        getUserInstitutions() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getUserInstitutions', {
                args: args
            });
        },

        getInstitutions() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getInstitutions', {
                args: args
            });
        },
        notEmpty(item) {
            return item.length > 0;
        },


        onSubmit: function (evt) {
            evt.preventDefault();

            this.$v.form.$touch();

            if (!_.isNull(this.form.dateRdv)) {
                this.form.dateRdv = moment(this.form.dateRdv).format('YYYY-MM-DD HH:mm');
            }
                let formData = new FormData();

                
                formData.append('etablissement_id', this.form.institution);
                formData.append('examen_complementaire_id', JSON.stringify(this.complementaireChecked));
                formData.append('prix', JSON.stringify(this.prix));
                // let self= this;

                // console.log('ligne_de_temps_id', this.form.ligne_de_temps_id);
                // console.log('etablissement_id', this.form.institution);
                let successMessage = this.$i18n.t('message.ExamenCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                // console.log("formData")
                // console.log(formData)
                this.$store.dispatch('createEtablissementPrice', {
                        args: formData,
                        errorMessages,
                        successMessage
                    })
                    .then(() => {
                        // Scroll to the top of the page
                        document.body.scrollTop = 0; // For Safari
                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    });

        },

        onAllergieSubmit: function (evt) {
            evt.preventDefault();

            this.$v.allergiesForm.$touch();
        },

        onReset: function (evt) {
            evt.preventDefault();

            // Reset our form values
            this.form.complementaire = '';

            // Trick to reset/clear native browser form validation state
            this.show = false;

            this.$nextTick(() => {
                this.show = true;
            });
        },

        getErrorsField(field) {
            if (this.errorshasField(field)) {
                return this.errors[field][0];
            } else {
                return '';
            }
        },

        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        clearErrorField(field) {
            this.$store.dispatch('clearErrorField', {
                field
            });

            this.getErrorsField(field);
        },
        getComplementaire: function () {
            return fetch(AppConfig.apiUrl + '/examen-complementaire', {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((json) => {
                    return json.examencomplementaire;
                    // var groups = this.groupBy(json.examencomplementaire);
                    // groups = Object.fromEntries(
                    //                 Object.entries(groups).sort( (a,b) => a[1].length - b[1].length )    
                    //             ) 
                    // console.log(groups)
                    // return groups;

                });
        },
        getPrice: function () {
            return fetch(AppConfig.apiUrl + '/examen-complementaire', {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((json) => {
                    var groups = this.groupBy(json.examencomplementaire);
                    // groups = Object.fromEntries(
                    //                 Object.entries(groups).sort( (a,b) => a[1].length - b[1].length )    
                    //             ) 
                    console.log(groups)
                    return groups;

                });
        },
        groupBy: function (collection) {
            const groups = collection.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                
                return groups;
            }, {});
            return groups;
        }
    },

    validations: {
        form: {

            complementaire: {
                //
            },
            complementaires: [],
            examen_complementaire: {
                //
            },
            prix: {
                //
            },
            institution: {
                required
            },
        },

    },

    mounted() {

        // Fetch user institution list
        this.getUserInstitutions();

        // Fetch institution list
        this.getInstitutions();


        new SlimSelect({
            select: '#institution',
            placeholder: 'Select institution',
            limit: 1
        });


        this.getComplementaire().then((data) => {
            this.complementaires = data;
        });

        var btn = $('#button');

        $(window).scroll(function () {
            if ($(window).scrollTop() > 300) {
                btn.addClass('show');
            } else {
                btn.removeClass('show');
            }
        });

        btn.on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, '300');
        });

   },
}

</script>